import { MsalAuthProvider, LoginType } from "react-aad-msal";

export const AuthProvider = new MsalAuthProvider(
  {
    auth: {
      authority: process.env.REACT_APP_AD_AUTHORITY,
      clientId: process.env.REACT_APP_AD_APPLICATION_ID,
      redirectUri: process.env.REACT_APP_AD_REDIRECT_URL
    },
    cache: {
      cacheLocation: "localStorage",
      storeAuthStateInCookie: false
    }
  },
  {
    scopes: ["User.Read"]
  },
  LoginType.Redirect
);
